<template>
  <el-tooltip
    v-if="img"
    class="item"
    effect="dark"
    placement="top-start"
    :content="title"
  >
    <img :src="img" :alt="title" class="vertical-label" />
  </el-tooltip>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import adult from '@/apps/traforama/assets/icons/verticals/adult.png'
import betting from '@/apps/traforama/assets/icons/verticals/betting.png'
import crypto from '@/apps/traforama/assets/icons/verticals/crypto.png'
import dating from '@/apps/traforama/assets/icons/verticals/dating.png'
import ecommerce from '@/apps/traforama/assets/icons/verticals/ecommerce.png'
import education from '@/apps/traforama/assets/icons/verticals/education.png'
import forex from '@/apps/traforama/assets/icons/verticals/forex.png'
import freetube from '@/apps/traforama/assets/icons/verticals/freetube.png'
import gambling from '@/apps/traforama/assets/icons/verticals/gambling.png'
import gaming from '@/apps/traforama/assets/icons/verticals/gaming.png'
import nutra from '@/apps/traforama/assets/icons/verticals/nutra.png'
import other from '@/apps/traforama/assets/icons/verticals/other.png'
import push from '@/apps/traforama/assets/icons/verticals/push.png'
import smartlink from '@/apps/traforama/assets/icons/verticals/smartlink.png'
import utilites from '@/apps/traforama/assets/icons/verticals/utilites.png'
import vouchers from '@/apps/traforama/assets/icons/verticals/vouchers.png'
import webcams from '@/apps/traforama/assets/icons/verticals/webcams.png'
import youtube from '@/apps/traforama/assets/icons/verticals/youtube.png'

const VerticalLabels: { [id: number]: any } = {
  1: dating,
  2: adult,
  3: ecommerce,
  4: nutra,
  5: gaming,
  6: vouchers,
  7: gambling,
  8: betting,
  9: education,
  10: webcams,
  11: utilites,
  12: forex,
  13: push,
  14: crypto,
  15: freetube,
  16: other,
  18: smartlink,
  19: youtube
}

export default defineComponent({
  name: 'VerticalLable',
  props: {
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const img = computed(() => {
      return VerticalLabels[props.id]
    })
    return { img }
  }
})
</script>
<style lang="scss" scoped>
.vertical-label {
  width: 30px;
}
</style>
